import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdjustmentType } from '../../event/models/adjustment-type.enum';

@Pipe({
  name: 'adjustmentType'
})
export class AdjustmentTypePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: string, args?: any): any {
    value = value.toUpperCase().toString();

    let returnValue = '';

    switch (value) {
      case AdjustmentType.PREPAYMENT.toString():
        returnValue = this.translateService.instant('ADJUSTMENT_REASON.PREPAYMENT');
        break;
      case AdjustmentType.REBATE.toString():
        returnValue = this.translateService.instant('ADJUSTMENT_REASON.REBATE');
        break;
      default:
        returnValue = this.translateService.instant('ADJUSTMENT_REASON.UNKNOWN', { key: value });
    }

    return returnValue;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/pipes/adjustment-type.pipe.ts